function initCrewlist(){

}

function initCrewlistSlider(){

    //console.log("initCrewlistSlider()")
    
    if ($(".crewlist").length > 0) {
        
        $(".crewlist").each(function () {
            
            return false;

            var $slider = $(this).find(".crewlist__slider");
            if($slider){
                //console.log("initCrewlistSlider() slider-length: " + $slider.children().length);
                //var $sliderSpan = $slider.children("span");
                //if($sliderSpan.length){
                    if($slider.hasClass("slick-initialized")){
                        $slider.slick('unslick');
                        console.log("initCrewlistSlider() slider unslick!");
                    }
                    
                    var s = $slider.slick({
                        dots: false,
                        infinite: true,
                        draggable: true,
                        slidesToShow: 1,
                        variableWidth: false,
                        adaptiveHeight: false,
                        prevArrow: slickPrevArrowCode,
                        nextArrow: slickNextArrowCode,
                        mobileFirst: true,
                        responsive: [
                            {
                                breakpoint: _breakpointMedium,
                                settings: "unslick"
                            }
                        ]
                    });
                //}
            }
            
        });
    }
}

var _initCrewlistCheck = false;
function handleCrewlistResize(){

    return false;

    _initCrewlistCheck = false;
    if ($(".crewlist").length > 0) {
        $(".crewlist").each(function () {
            var $slider = $(this).find(".crewlist__slider");
            if($slider){
                if($(window).width() < _breakpointMedium){
                    if(!$slider.hasClass("slick-slider")){
                        _initCrewlistCheck = true;
                    }
                }
            }
        });
    }

    if(_initCrewlistCheck){
        initCrewlistSlider();
    }
}